<template>
  <div class="wrapper">
    <Menu />
    <Header title="Ayarlar" />

    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div class="col-4 offset-4 text-center mt-3">
            <div class="user-image-edit w-100">
              <img src="/static/demoimages/32.jpg" class="w-100 rounded-circle" />
              <div class="edit-photo  d-flex align-self-center justify-content-center">
                <img src="/static/img/edit-photo.svg" alt="">
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="form-check radio-custom  bb-1 py-2">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck55" checked="">
              <label class="form-check-label" for="defaultCheck55">
                Bildirimleri Kapat
              </label>
            </div>
            <div class="form-check radio-custom  bb-1 py-2">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck56">
              <label class="form-check-label" for="defaultCheck56">
                Profili Aç
              </label>
            </div>
            <div class="form-check radio-custom  bb-1 py-2">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck57">
              <label class="form-check-label" for="defaultCheck57">
                Yorumlarda Adımı Gizle
              </label>
            </div>
          </div>
          <div class="col-12">
            <input type="text" class="form-input" placeholder="Eski Şifre">
            <input type="text" class="form-input" placeholder="Şifre">
            <input type="text" class="form-input" placeholder="Şifre Tekrar">
          </div>
          <div class="col-6">
            <button class="confirm-button mb-5">Değiştir</button>
          </div>
          <div class="col-12">
            <select class="form-select">
              <option>Erkek</option>
            </select>
            <input type="text" class="form-input" placeholder="00/00/1818">
            <select class="form-select">
              <option>İstanbul</option>
            </select>
            <select class="form-select">
              <option>Kadıköy</option>
            </select>
          </div>
          <div class="col-6">
            <button class="confirm-button mb-5">Değiştir</button>
          </div>
          <div class="col-12 fs-14 fc-3">

            <div class="form-check checkbox-custom">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck3">
              <label class="form-check-label" for="defaultCheck3">
                Anadolu Efes Spor Kulübü’nden e-posta
                almayı kabul ediyorum.
              </label>
            </div>
            <div class="form-check checkbox-custom">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck3">
              <label class="form-check-label" for="defaultCheck3">
                Anadolu Efes Spor Kulübü’nden e-posta
                almayı kabul ediyorum.
              </label>
            </div>

          </div>
          <div class="col-6">
            <button class="confirm-button">Değiştir</button>
          </div>
        </div>
      </div>
    </div>
    
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
export default {
  name: "AccountSettings",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/AccountSettings.vue